import React, { useEffect, useState } from 'react'
import { macStatus, webCargoMACMgtHeader } from '../constants'
import { Box, Button, Checkbox, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material'
import DropDownOA from '../../../common/dropDownOA'
import * as sx from '../../../common/stylesInline/report_daily_branch'
import FilterAltIcon from '@mui/icons-material/FilterAlt'
import TableCellTooltip from '../../../common/TableCellTooltip'
import moment from 'moment'
import { Item } from '../../../common/snippets'
import EditIcon from '@mui/icons-material/Edit'
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import CheckCircleOutlinedIcon from '@mui/icons-material/CheckCircleOutlined';
import { focusElemnt, isEmpty } from '../../../common/helper'
import LineInputV3 from '../../../common/lineInputV3'
import { connect } from 'react-redux'
import { getAllBranchName, getBranchMacDetailsTableData, updateBranchMacAddress } from '../../../../store/branchAndUserMaster/BUMAction'
import { updateAlertError } from '../../../../store/common/common_action'
import SuccessAndErrorModal from '../../../common/SuccessAndErrorModal'
const WebCargoMACMgt = (props) => {
    const { data, updateAlertError, getAllBranchName, getBranchMacDetailsTableData, updateBranchMacAddress,loginData } = props
    const { branchAndUserMasterReducer, common } = data
    const { MavenBranchDetailsTableData } = branchAndUserMasterReducer
    const [manageFocus, setManageFocus] = useState(false)
    const [status, setStatus] = useState(macStatus[1])
    const [macBranchName, setMacBranchName] = useState('')
    const [branchList, setBranchList] = useState([])
    const [selCompany, setSelCompany] = useState('')
    const [tableData, setTableData] = useState([])
    const [filteredData, setFilteredData] = useState([])
    const [filterValues, setFilterValues] = useState({});
    const [macAddress, setMacAddress] = useState('')
    const [isSuccess, setIsSuccess] = useState(false)
    const modalStyle = {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    }
    useEffect(() => {
        // if (MavenBranchDetailsTableData.length>0) {
        const data = MavenBranchDetailsTableData?.map((val, index) => ({ ...val, SN: index + 1, active: val.IsActive, editBtn: 1, updatedMacAddress: val.MacAddress }))
        setFilteredData(data)
        setTableData(data)
        // }else{
        //     setFilteredData()
        // }
    }, [MavenBranchDetailsTableData])
    useEffect(() => {
        if (!isEmpty(loginData)) {
            getBranchListData()
        } else {

        }
    }, [loginData?.intCompanyID])
    // useEffect(() => {
    //     setFilteredData(tableData)
    // }, [tableData])
    useEffect(() => {
        const filteredDataTemp = tableData.filter((item) => {
            return webCargoMACMgtHeader.every((column) => {
                const filterValue = filterValues[column.field] || "";
                const value = item[column.field]?.toString()
                return filterValue ? value && value.toString().toLowerCase().includes(filterValue.toLowerCase()) : true
            })
        })
        setFilteredData(filteredDataTemp)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filterValues])
    const handleChangeContain = (e, name) => {
        let value = e.target.value;
        setFilterValues((prevFilterValues) => ({
            ...prevFilterValues,
            [name]: value
        }));
    }
    const getBranchListData = () => {
        const object = {
            intUserID: loginData?.intUserID,
            intCompanyID: loginData?.intCompanyID,
            intBranchID: 0,
            strBranchName: "",
            strBranchCode: "",
            intStateID: 0,
            intCityID: 0,
            intIsActive: 1
        }
        getAllBranchName(object, true, 24 * 60 * 60 * 1000)?.then((res) => {
            if (res?.status === 'Success') {
                if (res?.Data?.Table?.length < 0) {
                    updateAlertError({ show: true, msg: 'No Data For Branch List', success: false, nextId: `maBranchName` })
                } else {
                    let branches = res?.Data?.Table?.map(obj => ({ name: obj.BranchName, id: obj.BranchID, city: obj.CityName }))
                    setBranchList(branches)
                    let filteredBranch = branches.filter(branch => branch.id === loginData?.intBranchID);
                    filteredBranch.length > 0 ? setMacBranchName(filteredBranch[0]) : setMacBranchName("")
                }
            } else {
                updateAlertError({ show: true, msg: res.Message, success: false, nextId: `maBranchName` })
            }
        }).catch((err) => {
            console.log("Error:", err)
        })
    }
    const handleHideEditBtn = (index) => {
        let newVal = [...filteredData]
        if (index >= 0 && index <= newVal?.length) {
            for (let i = 0; i < newVal?.length; i++) {
                if (i === index) {
                    newVal[i].editBtn = !newVal[i].editBtn
                } else {
                    newVal[i].editBtn = true
                }
            }
            setFilteredData(newVal)
            focusElemnt(`editBtn-${index + 1}`)
            newVal[index].editBtn === true ? setManageFocus(false) : setManageFocus(true)
        }
    }
    const handleRowEdit = (row, index) => {
        if (row?.updatedMacAddress === '') {
            updateAlertError({ show: true, msg: 'Please Enter The Mac Address', success: false, nextId: `mopPkngMethod-${index}` })
            return
        } else {
            let newVal = [...filteredData]
            const obj = {
                CompanyID: loginData?.intCompanyID,
                BranchID: row.branchid,
                MacAddress: row.updatedMacAddress,
                IsActive: row?.active,
                UserID: loginData?.intUserID
            }
            updateBranchMacAddress(obj)?.then((res) => {
                if (res?.status == 'Success') {
                    setIsSuccess(true)
                    if (index >= 0 && index <= newVal?.length) {
                        newVal[index].editBtn = !newVal[index].editBtn
                        setFilteredData(newVal)
                    }
                } else {
                    updateAlertError({ show: true, msg: res.Message, success: false, nextId: `editBtn-${index}` })
                }
            }).catch((err) => {
                console.log("Error:", err)
            })
        }
    }
    const handleCrossBtn = (index) => {
        let newVal = [...filteredData]
        if (index >= 0 && index <= newVal?.length) {
            newVal[index].updatedMacAddress = filteredData[index].MacAddress
            newVal[index].active = filteredData[index].IsActive
            newVal[index].editBtn = !newVal[index].editBtn
            setFilteredData(newVal)
            // setTimeout(() => {
            //     focusElemnt(`editBtn-${index + 1}`)
            // }, 0)
        }
    }
    const getTableData = () => {
        if (macBranchName === '') {
            updateAlertError({ show: true, msg: 'Please Select The Filters', success: false, nextId: `maBranchName` })
        } else {
            const object = {
                CompanyID: loginData?.intCompanyID,
                BranchID: macBranchName?.id,
                IsActive: status.id === 2 ? -1 : status.id
            }
            getBranchMacDetailsTableData(object)
        }
    }
    const handleSave = () => {
        const obj = {
            CompanyID: loginData?.intCompanyID,
            BranchID: macBranchName?.id,
            MacAddress: macAddress,
            IsActive: status.id,
            UserID: loginData?.intUserID
        }
        updateBranchMacAddress(obj)?.then((res) => {
            if (res?.status === 'Success') {
                setIsSuccess(true)
                setMacAddress('')
            } else {
                updateAlertError({ show: true, msg: res.Message, success: false, nextId: `maBranchName` })
            }
        }).catch((err) => {
            console.log("Error:", err)
        })
    }
    const handleRowChkChange = (e, index, item) => {
        let newVal = [...filteredData]
        if (index >= 0 && index <= newVal?.length) {
            newVal[index].active = e.target.checked ? 1 : 0
            // newVal[index].editBtn = !newVal[index].editBtn
            setFilteredData(newVal)
        }
    }
    const handleInputChange = (e, index) => {
        let newVal = [...filteredData]
        if (index >= 0 && index <= newVal?.length) {
            newVal[index].updatedMacAddress = e.target.value
            setFilteredData(newVal)
        }
    }
    const InsideRowContent = (item, index) => {
        const width = window.innerWidth - 40
        return (
            <TableRow key={`DR-${index}`}>
                <TableCell style={{ minHeight: '36px', textAlign: 'center', fontSize: '12px', color: '#666' }}>{index + 1}</TableCell>
                <TableCellTooltip
                    placement="bottom-start"
                    textAlign="left"
                    maxWidth={`${Math.ceil((width * webCargoMACMgtHeader.widthPercent) / 100)}px`}
                    title={item.CompanyName || ''}
                    data={item.CompanyName}
                />
                <TableCellTooltip
                    placement="bottom-start"
                    textAlign="left"
                    maxWidth={`${Math.ceil((width * webCargoMACMgtHeader.widthPercent) / 100)}px`}
                    title={item.BranchCity || ''}
                    data={item.BranchCity}
                />
                <TableCellTooltip
                    placement="bottom-start"
                    textAlign="left"
                    maxWidth={`${Math.ceil((width * webCargoMACMgtHeader.widthPercent) / 100)}px`}
                    title={item.branchname || ''}
                    data={item.branchname}
                />
                <TableCellTooltip
                    placement="bottom-start"
                    textAlign="left"
                    maxWidth={`${Math.ceil((width * webCargoMACMgtHeader.widthPercent) / 100)}px`}
                    title={item.BranchCode || ''}
                    data={item.BranchCode}
                />
                {
                    item.editBtn ?
                        <TableCellTooltip
                            placement="bottom-start"
                            textAlign="left"
                            maxWidth={`${Math.ceil((width * webCargoMACMgtHeader.widthPercent) / 100)}px`}
                            title={item.MacAddress || ''}
                            data={item.MacAddress}
                        /> :
                        <TableCell className="input--wrapper" style={{ fontSize: '12px', minHeight: '40px', color: '#444444', width: '23%', paddingRight: '30px' }}>
                            <Item sx={{ width: '100%', padding: '0px' }}>
                                <input
                                    id={`mopPkngMethod-${index}`}
                                    name={`mopPkngMethod-${index}`}
                                    className='input--style'
                                    // autoFocus={manageFocus}
                                    style={{ fontSize: "12px" }}
                                    value={item?.updatedMacAddress || ''}
                                    onChange={(e) => handleInputChange(e, index)}
                                // onKeyDown={(e) => { navigation1(e, `chkbox-${index}`, `checkMark-${index}`) }}
                                />
                            </Item>
                        </TableCell>
                }

                <TableCellTooltip
                    placement="bottom-start"
                    textAlign="left"
                    maxWidth={`${Math.ceil((width * webCargoMACMgtHeader.widthPercent) / 100)}px`}
                    title={item.ModifiedByUser || ''}
                    data={item.ModifiedByUser}
                />
                <TableCell style={{ minHeight: '36px', textAlign: 'left', fontSize: '12px', color: '#666' }}>{item.ModifiedDateTime !== "" ? moment(item.ModifiedDateTime).format('DD-MMM-YY, HH:mm') : ""}</TableCell>
                <TableCell style={{ minHeight: '36px', textAlign: 'left', fontSize: '12px', color: '#666', padding: '0px' }}>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <Checkbox id={`mm-checkbox-${index}`} checked={item.active === 1} sx={{ height: '36px' }}
                            onChange={(e) =>handleRowChkChange(e, index)}
                            // onKeyDown={(e) => {
                            //     handleChkBoxNavigation(e, index < filteredData?.length - 1 ? `mm-checkbox-${index + 1}` : 'mmSaveBtn', index === 0 ? 'mmSaveBtn' : `mm-checkbox-${index - 1}`)
                            // }}
                            disabled={item.editBtn}
                        />
                        {item.active === 1 ? 'Active' : 'InActive'}                        
                    </div>
                </TableCell>
                <TableCell style={{ textAlign: '-webkit-center', fontSize: '12px', minHeight: '40px', color: '#444444', width: '12%', padding: '0px 16px 0px 16px' }}>
                    {item.editBtn ? <span id={`editBtn-${index}`} tabIndex={0} style={{ display: 'flex', color: '#007bfd', fontSize: '13px', fontWeight: 'bold', width: '52px', padding: '2px 4px', marginLeft: '-6px', cursor: 'pointer' }}
                        onClick={() => { handleHideEditBtn(index) }}
                    // onKeyDown={(e) => navigation3(e, index === filteredData?.length - 1 ? 'mpkngMop' : `editBtn-${index + 1}`, index === 0 ? "mopAddBtn" : `editBtn-${index - 1}`, () => { handleHideEditBtn(index); })}
                    >
                        <EditIcon sx={{ marginRight: '3px', }} />
                        Edit
                    </span> :
                        <div style={{ display: 'flex', justifyContent: 'center', flexDirection: 'row', flexWrap: 'nowrap' }}>
                            <span tabIndex={0} key={`checkMark-${index}`} id={`checkMark-${index}`}
                                onClick={() => handleRowEdit(item, index)} style={{ marginRight: '5px', width: '28px', padding: '1px 1px', height: '30px', marginTop: '4px' }}
                            // onKeyDown={(e) => navigation3(e, `xMark-${index}`, `chkbox-${index}`, () => {handleRowEdit(item, index)})}
                            >
                                <CheckCircleOutlinedIcon tabIndex={0} style={{ color: '#4CAF50', marginTop: '1px' }} fontSize='large' />
                            </span>
                            <span key={`xMark-${index}`} tabIndex={0} id={`xMark-${index}`}
                                onClick={() => handleCrossBtn(index)} style={{ marginRight: '5px', width: '28px', padding: '1px 1px', height: '30px', marginTop: '4px' }}
                            // onKeyDown={(e) => navigation3(e, `mopPkngMethod-${index}`, `checkMark-${index}`, () => handleCrossBtn(index))}
                            >
                                <CancelOutlinedIcon tabIndex={0} style={{ color: 'red', marginTop: '1px' }} fontSize="large" />
                            </span>
                        </div>}
                </TableCell>
            </TableRow>
        )
    }
    return (
        <>
            <Box sx={{ ...sx.reportFlex, padding: '11px 0px 2px 0px', gap: '10px' }} className="reportButton">
                <Item sx={sx.itemsx}>
                    <DropDownOA
                        id="selectCompnay"
                        label="Selected Company"
                        defaultvalue={loginData.strCompanyName}
                        disabled={true}
                        onSelect={(val) => setSelCompany(val)}
                        width="100%"
                    />
                </Item>
                <Item sx={sx.itemsx}>
                    <DropDownOA id='maBranchName' label={'Branch Name'} minWidth="250px"
                        defaultvalue={macBranchName?.name || ''}
                        value={macBranchName?.name || ''}
                        data={branchList || []}
                        dataKey={`name`}
                        idKey={`id`}
                        onSelResetVal={true}
                        onSelect={(value) => {
                            setMacBranchName(value)
                        }}
                        prevId='maSaveBtn'
                        nextId='maUserName'
                        width="100%"
                    />
                </Item>
                <Item sx={sx.itemsx}>
                    <DropDownOA
                        id='mmStatus'
                        label={'Mac Status'}
                        minWidth="250px"
                        defaultvalue={status?.name || ''}
                        // value={status?.name || ''}
                        data={macStatus || []}
                        dataKey={`name`}
                        idKey={`id`}
                        // onSelResetVal={true}
                        onSelect={(value) => { setStatus(value) }}
                        prevId='mmBranchName'
                        nextId='mmLoadBtn'
                        width="100%"
                    />
                </Item>
                <Item sx={sx.itemsx} className="disabled-wrapper">
                    <Button id='mmLoadBtn' variant="contained"
                        style={{ ...sx.fullHeight, ...sx.novp }}
                        className="btn btn-primary"
                        onClick={() => { getTableData() }}
                    // onKeyDown={(e) => {
                    //     navigation1(e, 'mmSaveBtn', 'mmStatus');
                    // }}
                    >
                        LOAD
                    </Button>
                </Item>
                <Item className="input--wrapper" sx={sx.itemsx} style={{ width: '22%' }}>
                    <LineInputV3
                        id='mpkngMop'
                        autoFocus
                        sx={{ width: '100%', fontSize: '14px', fontFamily: 'Roboto', fontWeight: '400' }}
                        label={'Mac Address'}
                        value={macAddress}
                        onBlur={(e) => {
                            setMacAddress(e.target.value)
                        }}
                    // onKeyDown={(e) => {
                    //     navigation3(e, 'mopActive', filteredData?.length > 0 ? `editBtn-${filteredData?.length - 1}` : 'mopActive', () => { clickElement(`mpkngMop`) })
                    // }}
                    />
                </Item>
                <Item sx={sx.itemsx} className="disabled-wrapper">
                    <Button id='mmSaveBtn' variant="outlined"
                        style={{ height: '40px' }} color="secondary"
                        onClick={() => handleSave()}
                    // onKeyDown={(e) => {
                    //     navigation1(e, filteredData?.length > 0 ? 'mm-checkbox-0' : 'mmBranchName', 'mmLoadBtn');
                    // }}
                    >
                        SAVE NEW MAC
                    </Button>
                </Item>
            </Box>
            <Box sx={{ margin: '16px 0px 0px 0px' }}>
                <TableContainer component={Paper} className="scrollBlue" style={{ maxHeight: '60vh', marginBottom: '5px' }}>
                    <Table
                        stickyHeader
                        size="small"
                        aria-label="a dense table"
                        sx={{
                            '& .MuiTableCell-root': {
                                padding: '6px',
                                color: '#444',
                                lineHeight: 1
                            },
                        }}
                    >
                        <TableHead style={{ position: `sticky`, top: `0`, zIndex: '2', whiteSpace: 'pre' }}>
                            <TableRow>
                                {webCargoMACMgtHeader.map((col, index) => (
                                    <TableCell
                                        key={`TH-${index}`}
                                        style={{
                                            ...col.headerSx,
                                            backgroundColor: '#DAEDFE',
                                            height: '36px',
                                            fontSize: '12px',
                                            fontWeight: '600',
                                            // width: col.fixedWidth
                                            //     ? `${col.fixedWidth}px`
                                            //     : `${Math.ceil((width * col.widthPercent) / 100)}px`,
                                        }}
                                    >
                                        {col.headerName}
                                    </TableCell>
                                ))}
                            </TableRow>
                            <TableRow>
                                {webCargoMACMgtHeader.map((col, index) =>
                                    col.showfilter ? (
                                        <TableCell key={`FTH-${index}`} sx={col?.headerSx}>
                                            <div className="filter-input" style={{ fontSize: '12px', justifyContent: 'space-between' }}>
                                                <input
                                                    id={`index-${index}`}
                                                    className="field"
                                                    name="cancelSearchInput"
                                                    style={{ width: '100%' }}
                                                    placeholder="Contains"
                                                    onChange={(e) => handleChangeContain(e, col.field)}
                                                // onKeyDown={(e) => navigation1(e, index === 5 ? `index-1` : `index-${index + 1}`, index === 1 ? `index-5` : `index-${index - 1}`)}
                                                />
                                                <FilterAltIcon />
                                            </div>
                                        </TableCell>
                                    ) : (
                                        <TableCell key={`empty-cell-${index}`}></TableCell>
                                    )
                                )}
                            </TableRow>
                        </TableHead>
                        {filteredData?.length <= 0 ? (
                            <>
                                <TableBody>
                                    <TableRow>
                                        <TableCell colSpan={14}>
                                            <div
                                                style={{
                                                    display: 'flex',
                                                    justifyContent: 'center',
                                                    marginTop: '20px',
                                                    marginBottom: '20px',
                                                    color: 'red',
                                                    fontSize: '14px',
                                                }}
                                            >
                                                <span>No results found. Please refine your search parameters and search again.</span>
                                            </div>
                                        </TableCell>
                                    </TableRow>
                                </TableBody>
                            </>
                        ) : filteredData.length > 0 ? (
                            <TableBody className="filter-data-row-BorderNone" sx={{ border: 'none !important' }}>
                                {filteredData?.map((item, index) => InsideRowContent(item, index))}
                                {/* <InsideRowContent/> */}
                            </TableBody>
                        ) : (
                            ''
                        )}
                    </Table>
                </TableContainer>
            </Box>
            <SuccessAndErrorModal handleClose={() => { setIsSuccess(false); getTableData(); focusElemnt('maBranchName') }} open={isSuccess} title={'Mac Address\n Saved Successfully'} modalStyle={modalStyle} />
        </>
    )
}
const mapStateToProps = (data) => ({ data })
const mapDispatchToProps = { getAllBranchName, updateAlertError, getBranchMacDetailsTableData, updateBranchMacAddress }
export default connect(mapStateToProps, mapDispatchToProps)(WebCargoMACMgt)
